/* eslint-disable @wordpress/no-global-event-listener */

export class FilterCheckboxes {
	/*
	 * Init the handler
	 *
	 * @param    {HTMLElment} rootEl       The root element of the filter
	 * @param    {string}     rootClass    The root class of the filter
	 */
	constructor(rootEl, rootClass) {
		this.rootEl = rootEl;
		this.rootClass = rootClass;
		this.titleClass = `${rootClass}__title`;
		this.titleCountClass = `${this.titleClass}-count`;
		this.openClass = `${rootClass}--open`;
		this.desktopThreshold = 1200;

		this.rootEl.addEventListener('click', this.titleClicked.bind(this));
		this.rootEl.addEventListener('change', this.updateCount.bind(this));
		document.addEventListener('click', this.documentClicked.bind(this));
		window.addEventListener('resize', this.close.bind(this), {
			passive: true,
		});

		this.updateCount();
	}

	/*
	 * Update the selected filter count within the title element
	 *
	 * @return    {void}
	 */
	updateCount() {
		const checkboxEls = Array.from(
			this.rootEl.querySelectorAll('input[type="checkbox"]:checked')
		);
		const countEl = this.rootEl.querySelector(`.${this.titleCountClass}`);
		this.rootEl.dataset.selectedCount = String(checkboxEls.length);
		countEl.innerText = String(checkboxEls.length);
	}

	/*
	 * Close the filter
	 *
	 * @return    {void}
	 */
	close() {
		this.rootEl.classList.remove(this.openClass);
	}

	/*
	 * Clicking outside the rootEl will close the list
	 *
	 * @param     {MouseEvent} event    The event raised by a user action
	 * @return    {void}
	 */
	documentClicked(event) {
		// Close this filter if the root element doesn't match
		const rootEl = event.target.closest(`.${this.rootClass}`);
		if (rootEl !== this.rootEl) {
			this.close();
		}
	}

	/*
	 * Clicking the title will toggle the open state of the list
	 *
	 * @param     {MouseEvent} event    The event raised by a user action
	 * @return    {void}
	 */
	titleClicked(event) {
		const targetEl = event.target;
		const matchesSelector = `.${this.titleClass}`;

		// Make sure the target el is the title or a child of the title
		if (
			!targetEl.matches(matchesSelector) &&
			!targetEl.matches(`${matchesSelector} *`)
		) {
			return;
		}

		// Toggle the open state
		this.rootEl.classList.toggle(this.openClass);

		// Emit an open event
		if (this.rootEl.classList.contains(this.openClass)) {
			const event = new window.Event('open');
			this.rootEl.dispatchEvent(event);
		}
	}
}
